import type { TCountryCode } from "countries-list";
import { byIso } from "country-code-lookup";
import type { FC } from "react";
import { useSiteList } from "../../../../../hooks/use-site-list";
import Link from "../../../Link";
import * as s from "./SidebarSiteSelectionListItem.module.scss";

type SidebarSiteSelectionListItemProps = {
	setCountryAndCloseModal: (country: TCountryCode) => void;
};

const SidebarSiteSelectionListItem: FC<SidebarSiteSelectionListItemProps> = ({
	setCountryAndCloseModal,
}) => {
	const sites = useSiteList();

	return (
		<ul className={s.countryList}>
			{sites.map((site) => (
				<li key={`${site.domain}-${site.countryIso}`}>
					{site.isSameSite ? (
						<button
							className={s.countryButton}
							onClick={() => setCountryAndCloseModal(site.countryIso)}
						>
							{byIso(site.countryIso)?.country} |{" "}
							{(site.language || "").split("-")[0]?.toUpperCase()}
						</button>
					) : (
						<Link
							href={`https://${site.domain}?country=${site.countryIso}`}
							className={s.country}
						>
							{byIso(site.countryIso)?.country} |{" "}
							{(site.language || "").split("-")[0]?.toUpperCase()}
						</Link>
					)}
				</li>
			))}
		</ul>
	);
};
export default SidebarSiteSelectionListItem;
